import { editIncident } from 'common/constants/permissions';

const canEditIncident = permissions => !!permissions[editIncident];

export default {
    canEditIncident
};
